import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../../app/stores/rootStore";

const CompanyInfo = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { broker, getBroker } = rootStore.companyStore;
  
  useEffect(() => {
    getBroker();
  }, [getBroker]);


  return (
    <div className="tabContentStyle">
      <label>Nombre o Razón Social del emisor</label>
      <p className="readonlyfield">{broker.registrationName}</p>
      <label>Nombre Comercial</label>
      <p className="readonlyfield">{broker.name}</p>
      <label>NIT del emisor</label>
      <p className="readonlyfield">{broker.companyID}</p>
      <label>DV del NIT del emisor</label>
      <p className="readonlyfield">{broker.digitCheck}</p>
      <label>Dirección</label>
      <p className="readonlyfield">
        {broker.address?.line || '\u00A0'}
      </p>
      <label>Email</label>
      <p className="readonlyfield">
        {broker.contact?.email || '\u00A0'}
      </p>
      <label>Teléfono</label>
      <p className="readonlyfield">
        {broker.contact?.phone || '\u00A0'}
      </p>
      <label>Tipo de identificador fiscal</label>
      <p className="readonlyfield">31-NIT</p>
      <label>Código dentificador del país</label>
      <p className="readonlyfield">CO-Colombia</p>
      <label>Departamento</label>
      <p className="readonlyfield">
        {broker.address?.countrySubentity || '\u00A0'}
      </p>
      <label>Ciudad</label>
      <p className="readonlyfield">
        {broker.address?.cityName || '\u00A0'}
      </p>
      <label>Código postal</label>
      <p className="readonlyfield">
        {broker.address?.postalZone || '\u00A0'}
      </p>
    </div>
  );
};

export default observer(CompanyInfo);
